import React, { FunctionComponent, useContext, ChangeEvent } from "react";
import { Routes } from "../../app";
import { Choice, Alert } from "@cmsgov/ds-medicare-gov";
import { CoverageType } from "./types";
import { useTranslate } from "../../helpers";
import { FormattedMessage } from "react-intl-phraseapp";
import { Continue } from "../../components";
import { AppContext } from "../../app/store";

interface PlanQuestionsProps {
  handleChoice: (e: ChangeEvent<HTMLInputElement>) => void;
  coverageSelection: CoverageType;
  hideMedigapButton?: boolean;
}

const PlanQuestions: FunctionComponent<PlanQuestionsProps> = ({
  handleChoice,
  coverageSelection,
  hideMedigapButton,
}) => {
  const t = useTranslate();
  const {
    state: { language },
  } = useContext(AppContext);

  const mapdSelected = coverageSelection === CoverageType.MAPD;
  const pdpSelected = coverageSelection === CoverageType.PDP;
  const medigapSelected = coverageSelection === CoverageType.MedigapPolicy;
  const pdpMedigapSelected = coverageSelection === CoverageType.PDPAndMedigap;

  return (
    <>
      <Choice
        type="radio"
        name="what-coverage"
        id="what-coverage-mapd"
        value={CoverageType.MAPD}
        onChange={handleChoice}
        checked={mapdSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.mapd.text")}
          </Alert>
        }
      >
        {t("landing_page.coverage_selection.mapd.heading")}
      </Choice>

      <Choice
        type="radio"
        name="what-coverage"
        id="what-coverage-pdp"
        value={CoverageType.PDP}
        onChange={handleChoice}
        checked={pdpSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.pdp.text")}
          </Alert>
        }
      >
        <FormattedMessage
          id="landing_page.coverage_selection.pdp.heading"
          tagName="span"
          values={{
            message: <span aria-label="Dee">D</span>,
          }}
        />
      </Choice>

      <Choice
        type="radio"
        name="what-coverage"
        id="what-coverage-pdp-medigap"
        value={CoverageType.PDPAndMedigap}
        onChange={handleChoice}
        checked={pdpMedigapSelected}
        checkedChildren={
          <Alert role="alert" hideIcon={true}>
            {t("landing_page.coverage_selection.pdp_medigap.text")}
          </Alert>
        }
      >
        <FormattedMessage
          id="landing_page.coverage_selection.pdp_medigap.heading"
          tagName="span"
          values={{
            message: <span aria-label="Dee">D</span>,
          }}
        />
      </Choice>

      <Choice
        type="radio"
        name="what-coverage"
        id="what-coverage-medigap"
        value={CoverageType.MedigapPolicy}
        onChange={handleChoice}
        checked={medigapSelected}
        checkedChildren={
          <>
            <Alert role="alert" hideIcon={true}>
              {t("landing_page.coverage_selection.medigap.text")}
            </Alert>
            {!hideMedigapButton && (
              <>
                <Continue
                  useLink
                  to={`#${Routes.medigap.landingPage}?lang=${language}`}
                >
                  {t("landing_page.coverage_selection.view_policies")}
                </Continue>
              </>
            )}
          </>
        }
      >
        {t("landing_page.coverage_selection.medigap.heading")}
      </Choice>
    </>
  );
};

export default PlanQuestions;
